// Copyright (c) 2019, 2020 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";

import {
  SchoolDocument,
  AdministratorDocument,
  VolunteerDocument,
} from "../store/schema";
import { PageHeader } from "../components/PageHeader";
import { PageFooter } from "../components/PageFooter";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { Breadcrumb } from "./BreadCrumb";
import { User } from "../store/api";
import { URLS } from "../urls";
import { Link } from "react-router-dom";

interface StateChecks {
  user?: User | null;
  loaded?: boolean;
  volunteer?: VolunteerDocument | null;
}

interface PageContainerProps {
  title: string;
  crumbs: Breadcrumb[];
  administrators: AdministratorDocument[];
  school: SchoolDocument | null;
  isCoordinator?: boolean;
  checks: StateChecks;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  title,
  crumbs,
  school,
  administrators,
  isCoordinator,
  checks,
  children,
}) => {
  const { user, loaded, volunteer } = checks;
  console.log("PageContainer:");
  console.log({
    title,
    crumbs,
    school,
    administrators,
    isCoordinator,
    checks,
    children,
  });
  return (
    <ErrorBoundary>
      <div>
        <PageHeader crumbs={crumbs} school={school && school.data} />
        {user == null ? (
          <div className="loading">
            <h2>
              <Link to={URLS.login()}>Authenticating...</Link>
            </h2>
          </div>
        ) : loaded === false ? (
          <div className="loading">
            <h2>Loading...</h2>
          </div>
        ) : (!isCoordinator && volunteer === null) ? (
          <div className="content">
            You need to set up <Link to={URLS.vProfile()}>your profile</Link>{" "}
            first.
          </div>
        ) : (
                <div className="content">
                  <div className="title">
                    <h2>{title}</h2>
                  </div>
                  {children}
                </div>
              )}
        <PageFooter administrators={administrators} school={school} isCoordinator={!!isCoordinator} />
      </div>
    </ErrorBoundary>
  );
};
